import React from 'react';
import TimetableDisplay from './TimetableDisplay.js';
import TimetableForm from './TimetableForm';



const Timetable = () => {
  return (
    <div>
      <TimetableDisplay/>
      <TimetableForm/>
      
    </div>
  );
};

export default Timetable;
